export default __webpack_public_path__ + "static/media/dialysis-chair.34c78749.jpg";